module.exports = __webpack_public_path__ + "media/images/play-circle-regular-b3fc55f5.svg";